module.exports = CompetitionService;

function CompetitionService() {
	// Entry method for all competitions except for the instant win competition
	this.enter = function(payload) {
		var url = '/competition/api/v1/enter';
		return $.ajax({
			url: url,
			type: 'POST',
			data: payload
		});
	};
}